import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const EMPTY_PRODUCT_SETTINGS = {
  id: '',
  effects: [
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
      ],
      selectValues: ['NONE'],
    },
    {
      formControlNames: [SUMMARY_REFERENCE_ENTITIES],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS_GROUP],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_REFERENCE_RATE],
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: [null],
      readOnly: false,
    },
  ],
};
